import { createTheme } from '@mui/material/styles';

export const TEAM_COLORS = {
  primary: '#1976d2',
  secondary: '#dc004e',
  accent: '#764ba2',
};

export const loadTeamColorsFromStorage = () => {
  try {
    const stored = localStorage.getItem('concordare_team_colors');
    if (stored) {
      return JSON.parse(stored);
    }
  } catch {
    // ignore
  }
  return TEAM_COLORS;
};

export const saveTeamColorsToStorage = (colors) => {
  try {
    localStorage.setItem('concordare_team_colors', JSON.stringify(colors));
  } catch {
    // ignore
  }
};

const colors = loadTeamColorsFromStorage();

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: colors.primary,
    },
    secondary: {
      main: colors.secondary,
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
  },
});

export default theme;
